import { ToastContext } from "context/ToastContext";
import { useUserWithAccount } from "context/UserAccountProvider";
import { useQuery } from "hooks/useQuery";
import { useContext, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanUpServiceDetails } from "store/slices/serviceDetails";

import { OrderFormHeader } from "../OrderFormHeader";

export function DraftHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { current: toastElement } = useContext(ToastContext);
  const query = useQuery();
  const accountId = query.get("accountId") || undefined;
  const { accounts } = useUserWithAccount();

  const accountName = useMemo(() => {
    if (!accounts || !accountId) return "";
    const account = accounts.data.find((acc) => acc.id === accountId);
    return account?.name || "";
  }, [accounts]);

  const backToOrderList = () => {
    dispatch(cleanUpServiceDetails());
    navigate(`/hospitals/view/${accountId}/orders`);
    toastElement?.show({
      severity: "warn",
      summary: "Exit review",
      detail: "Progress not saved",
    });
  };

  return (
    <OrderFormHeader
      title="Review Estimate"
      accountName={accountName}
      onBack={backToOrderList}
      onCancel={backToOrderList}
    />
  );
}
